<template>
  <b-form-group
    label="メールアドレス"
  >
    <b-form-input
      type="email"
      v-model="model"
      placeholder="test@example.com"
    >
    </b-form-input>
  </b-form-group>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'settings/userInfo',
      attribute: 'email'
    }
  },

  computed: {
    model: {
      get () {
        return this.$store.getters[`${this.modelName}/getAttr`](this.attribute)
      },

      set (value) {
        this.$store.commit(`${this.modelName}/setAttr`, {
          name: this.attribute,
          value
        })
      }
    }
  }
}
</script>
